module.exports = __webpack_public_path__ + "img/41eceacec37f25e2794edfa0bf4acb4b.svg";